<template>
    <ProfessionsList />
  </template>
  
  <script>
  import ProfessionsList from '@/components/common/profession/ProfessionsList.vue'
  
  export default {
    name: 'ListProfessions',
    components: { ProfessionsList }
  }
  </script>
  
  <style scoped>
  
  </style>
  